import { CodedError } from '../CodedError';
import { errorCodeTypes } from './errorCodeTypes';

export class EmptyTenantLeaseIdError extends CodedError {
  static get errorName() {
    return errorCodeTypes.emptyTenantLeaseIdError.code;
  }

  constructor(message = errorCodeTypes.emptyTenantLeaseIdError.message) {
    super(message);
    this.code = errorCodeTypes.emptyTenantLeaseIdError.code;
    this.message = `${message} ${errorCodeTypes.emptyTenantLeaseIdError.code}`;
    this.name = errorCodeTypes.emptyTenantLeaseIdError.name;
  }
}
